import PlayerTimelineButton from './PlayerTimelineButton';
import { useAddScene } from '../TimelineSegments/TimelineScenes/useAddScene';
import useEditorRestrictions from '@/hooks/useEditorRestrictions';

const AddScene = () => {
  const { addSceneMenuItem } = useAddScene();
  const { isBlocked } = useEditorRestrictions();
  if (!addSceneMenuItem) {
    return null;
  }

  return (
    <PlayerTimelineButton
      tooltipTitle={addSceneMenuItem.label}
      buttonId="timeline-add-scene-button"
      iconName={addSceneMenuItem.iconName}
      isDisabled={addSceneMenuItem.isDisabled || isBlocked('timeline-scene-add')}
      onClick={addSceneMenuItem.onClick}
    />
  );
};

export default AddScene;
